import React, { useEffect } from 'react';
import { FaqList, Progress, TitleHeader } from 'web-library';
import { useTranslation } from 'react-i18next';
import { useGetAnnouncementConfig } from '../../api-refactored/announcements-configuration/useGetAnnouncementConfig';
import { usePostSearchAnnouncements } from '../../api-refactored/announcements/usePostSearchAnnouncements';

const ANNOUNCEMENT_TYPE = 'FAQ';

const Faq = () => {
  const { t } = useTranslation();

  const { data: faqDetailPage, mutate: postSearchFaqs } = usePostSearchAnnouncements();

  const { data: faqConfig } = useGetAnnouncementConfig({
    announcementType: ANNOUNCEMENT_TYPE,
  });

  useEffect(() => {
    postSearchFaqs({
      apiPathParam: {},
      announcementType: ANNOUNCEMENT_TYPE,
      q: '',
    });
  }, [postSearchFaqs]);

  if (!faqDetailPage || !faqConfig) {
    return <Progress color="secondary" />;
  }

  return (
    <>
      <TitleHeader title={t('helpdesk->>PageTitle.FAQ')} />

      <FaqList faqDetailPage={faqDetailPage} faqConfig={faqConfig} />
    </>
  );
};

export default Faq;
